import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Messages } from "../../model/messages";
import { TicketService } from "../../services/ticket.service";
import { Ticket } from "../../model/ticket";
import { AuthService } from "../../auth.service";
import { MultiActionService } from "../../services/multi-action.service";
import { SingleChoice } from "../../model/singlechoice";
import { BehaviorSubject } from "rxjs";
import { MultiAction } from "../../model/multi-action";
import { Router } from "@angular/router";
import { Labeler } from "../../model/labeler";

@Component({
    selector: "multi-action",

    templateUrl: "./multi-action.component.html",
    styleUrl: "./multi-action.component.css",
})
export class MultiActionComponent {
    messages: BehaviorSubject<Messages>;
    @Output() actionSelected = new EventEmitter<number>();
    @Input() choiceEvent: SingleChoice = SingleChoice.EMPTY;
    actions: BehaviorSubject<MultiAction[]>;
    selectedAction: MultiAction | null = null;

    constructor(
        private multiActionService: MultiActionService,
        private authService: AuthService,
        private router: Router
    ) {
        this.messages = new BehaviorSubject(Messages.EMPTY);
        this.actions = new BehaviorSubject<MultiAction[]>([]);
    }

    ngOnInit(): void {
        const token = this.authService.token;

        this.multiActionService.actionsAll(token).subscribe({
            next: (messages) => {
                if (messages.hasAnyMessages) {
                    this.messages.next(messages);
                }
            },
            complete: () => { },
        });

        this.multiActionService.actionObservable.subscribe((data) => {
            const sortedAction = data.sort((a: MultiAction, b: MultiAction) =>
                a.name.localeCompare(b.name)
            );
            this.actions.next(sortedAction);
        });
    }

    select(action: MultiAction) {
        if (this.choiceEvent && this.choiceEvent.topic == "multi-action") {
            if (action && action.id) {
                this.multiActionService
                    .makeBackgroundColor(action.id)
                    .subscribe((background) => {
                        this.multiActionService
                            .makeColor(action.id!!)
                            .subscribe((color) => {
                                this.choiceEvent.choose(
                                    action.id!!,
                                    action.name,
                                    background,
                                    color,
                                    1
                                );
                            });
                    });
            }
            this.multiActionService.select(action);
        } else {
            if (action && action.id) {
                this.router.navigate([`multi-action/${action.id}`]).then(() => {
                    this.actionSelected.emit(action.id!!);
                });
            }
        }
    }

    get TRUE(): boolean {
        return true;
    }
    get FALSE(): boolean {
        return false;
    }

    get actionLabelerByService(): Labeler {
        return this.multiActionService;
    }
    getIconForAction(action: MultiAction): string {
        switch (action.name.toLowerCase()) {
            case "action.archive":
                return "archive";
            case "action.activate":
                return "unarchive";
            case "action.done":
                return "done";
            case "action.in_progress":
                return "hourglass_top";
            case "action.wait":
                return "schedule";
            case "action.clear":
                return "clear";
            default:
                return "change_circle";
        }
    }
}
